import React from "react";

export default function Marquee({ items = [], className = "" }) {
  const doubled = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} data-testid="marquee">
      <div className="marquee-track items-center gap-10">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display text-2xl md:text-4xl font-medium whitespace-nowrap">{item}</span>
            <span className="w-2 h-2 rounded-full bg-secondary shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
